import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import styles from './scss/view-uploaded-files-slider.scss';
import SliderWrapper from 'jd-library/SliderWrapper';
import {toggleEditDisplayNameModal, renameAttachmentFile, resetFileAttachmentData} from '../../../actions/products';
import historyHandler from "jd-library/historyHandler";
import { universalClose } from "../../../utills";
import UploadFilesView from "./UploadFilesView";

const ViewUploadedFilesSlider = (props) => {
     const [hideAddButton, toggleBtn] = useState(true);
     useEffect(()=> {
        setTimeout(()=>{
             toggleBtn(props.hideAddButton);
        },1200)  
     },[props.hideAddButton]);

     useEffect(() => {
          if(props.progressProps.allDeleted){
               toggleBtn(props.hideAddButton);
          }
     },[props.progressProps.allDeleted]);
     
     const closeSlider = () => {
         props.closeSlider();
     }

     const sliderWrapProps = {
		header: {
                    heading: 'Files',
                    className: `${styles['view-upload-files-header']}`,
                    leftIcons: [{
                         className: 'icon-HDRback',
                         onClick: (e) => {
                              historyHandler.closeCurrent();
                         }
                    }],
			},
          slider: {
               className: `${styles['view-uploaded-files-slider']} ${props.deviceData.isMobile ? '': 'isWeb'}`,
          },
		onHidden: () => {
			props.closeSlider();
               universalClose(props.fromSellerDashboard,historyHandler,true)
		}
    };

    const saveDisplayName = (inputObj) => {
          let fileName = inputObj[0].input.value;
          props.renameAttachmentFile({fileName, productId: props.productId, fileKey:props.currentFile.fileKey});
    }

    const validateInput = (inputObj, validateCB) => {
     let inputField = inputObj[0];
          if(!inputField.input.value){
               validateCB({isError: true, errorMsg: 'Please Enter Display Name', inputField});
          }else{
               validateCB({isError: false, errorMsg: ''});
          }
    }

     return(
          <>
               <SliderWrapper
               {...sliderWrapProps}
               >
                    <UploadFilesView 
                    {...props}
                    hideAddButton={hideAddButton}
                    validateInput={validateInput}
                    saveDisplayName={saveDisplayName}
                    fromAttachment={true}
               />
              </SliderWrapper>
         </>      
     )
}

const mapStateToProps = (state,props) => {
	return {
		...props,
          fileAttachmentArr : state.products?.allProducts?.[props.productId]?.fileAttachmentArr || [],
          uploadedFileModalData: state.products.uploadedFileModalData,
          deviceData: state.deviceData,
          isReadOnly: state.session.isReadOnly,
          ...state.products.fileAttachmentData,
          permissionData: state.products.fileAttachmentData.permissionData,
          ownerName: state.permissions.ownerName,
          packageId: state.permissions.packageId,
          storeName: state.permissions.storeName,
          ownerMobileNumber: state.permissions.ownerMobileNumber,
          ownerEmail: state.permissions.ownerEmail,
          fromSellerDashboard: state.products.fromSellerDashboard,
	}
}
export default connect(mapStateToProps, {toggleEditDisplayNameModal, renameAttachmentFile, resetFileAttachmentData})(ViewUploadedFilesSlider);